import { FC } from "react";
import InputWrapper from "./InputWrapper";

// A clock the form works out rather than asks for: the trip's arrival, a stop's time. Drawn with
// the same border as the fields around it so the row reads as one line of boxes, but greyed and
// not editable. When the clock lands on a later day than the departure, the day count sits inside
// the box after it: "02:00 (+1 ditë)".
const ReadOnlyClockField: FC<{
  id: string;
  label: string;
  clock: string;
  days: number;
}> = ({ id, label, clock, days }) => (
  <InputWrapper id={id} label={label}>
    <div
      id={id}
      className={"flex items-center h-11 rounded-lg ring-1 ring-blue-stroke bg-gray-50 px-3 " +
        "text-sm text-neutral select-none whitespace-nowrap cursor-default"}
      title="Llogaritet automatikisht nga nisja dhe kohëzgjatja"
      aria-live="polite"
    >
      {clock ? (
        <>
          <span>{clock}</span>
          {days > 0 && <span className="ml-1.5 text-xs text-gray-600">(+{days} ditë)</span>}
        </>
      ) : (
        <span className="text-gray-400">--:--</span>
      )}
    </div>
  </InputWrapper>
);

export default ReadOnlyClockField;
